import React from 'react';
import NavPills from 'components/NavPills/NavPills.js';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import d2rsIcon from '../../assets/img/d2rsiconblock.png';
// import cubeImg from '../../assets/img/horadric_cube.png';

const recipesAndMisc = [
  {
    name: 'Upping',
    content: (
      <Card>
        <CardBody>
          <div>
            <div style={{ color: 'white' }}>
              TAGS: UPPING DEFENSE; PERFECT DEFENSE; PERFECT UPPING DEFENSE; PERFECT UPPED DEFENSE;
              UNIQUE UPPED DEFENSE;
            </div>
            <div>
              <img src="https://i.postimg.cc/44YRy8DH/uppeds.jpg" alt="Upped Defense" />
            </div>
          </div>
        </CardBody>
      </Card>
    ),
  },
  {
    name: 'Sockets',
    content: (
      <Card>
        <CardBody>
          <div>
            <div style={{ color: 'white' }}>
              TAGS: SOCKETS; SOCKET RECIPE; EBUG RECIPE; ETH ARMOR; ETHEREAL ARMOR; SOCKETED; SOCKET
              ARMOR; SHIELD; HELMET; ARMOR;
            </div>
            <div>
              <img src="https://i.postimg.cc/hP19Rbjg/sockets.jpg" alt="Sockets" />
            </div>
          </div>
        </CardBody>
      </Card>
    ),
  },
  {
    name: 'Base Upgrades',
    content: (
      <Card>
        <CardBody>
          <div>
            <div style={{ color: 'white' }}>
              TAGS: UPPING RECIPE; UP RECIPE; NORMAL UNIQUE ARMOR; EXCEPTIONAL UNIQUE ARMOR; ELITE
              UNIQUE ARMOR; NORMAL RARE ARMOR; EXCEPTIONAL RARE ARMOR; ELITE RATE ARMOR;
            </div>
            <div>
              <img src="https://i.postimg.cc/xdJJ8K0X/upgrades.jpg" alt="Upgrades" />
            </div>
          </div>
        </CardBody>
      </Card>
    ),
  },
  {
    name: 'Re-Rolls',
    content: (
      <Card>
        <CardBody>
          <div>
            <div style={{ color: 'white' }}>
              TAGS: REROLLING MAGIC ITEM; REROLLING SMALL CHARM; REROLLING GRAND CHARM;
            </div>
            <div>
              <img src="https://i.postimg.cc/ncZ4hW5n/fixed.jpg" alt="Rerolling" />
            </div>
          </div>
        </CardBody>
      </Card>
    ),
  },
  {
    name: 'Blood Crafting',
    content: (
      <Card>
        <CardBody>
          <div>
            <div style={{ color: 'white' }}>
              TAGS: CRAFTING RECIPE; BLOOD CRAFTING; BLOOD HELM; BLOOD BOOTS; BLOOD BELT; BLOOD
              RING;
            </div>
            <div>
              <img src="https://i.postimg.cc/Kc9yLrBk/bloodklar2.jpg" alt="Blood Crafting" />
            </div>
          </div>
        </CardBody>
      </Card>
    ),
  },
  {
    name: 'Power & Caster Crafting',
    content: (
      <Card>
        <CardBody>
          <div>
            <div style={{ color: 'white' }}>
              TAGS: CRAFTING RECIPE; CASTER RING; CASTER AMULET; CASTER CRAFTING; POWER CRAFTING;
              POWER GLOVES; POWER BELT;
            </div>
            <div>
              <img src="https://i.postimg.cc/NMwTTx7P/4donepsdupdate.jpg" alt="Caster Crafting" />
            </div>
          </div>
        </CardBody>
      </Card>
    ),
  },
  {
    name: 'Runes',
    content: (
      <Card>
        <CardBody>
          <div>
            <div style={{ color: 'white' }}>
              TAGS: RUNE UPGRADING; RUNES; PUL; UM; MAL; IST; GUL; VEX; OHM; LO; SUR; BER; JAH;
              CHAM; ZOD
            </div>
            <div>
              <img src="https://i.postimg.cc/KvkKvCm0/runesklar2-kopia.jpg" alt="Runes" />
            </div>
          </div>
        </CardBody>
      </Card>
    ),
  },
  {
    name: 'Mercenaries',
    content: (
      <Card>
        <CardBody>
          <div>
            <div style={{ color: 'white' }}>
              TAGS: ACT 2 MERC; A2 AURA; A2 OFFENSIVE; A2 OFFENSE; A2 OFFENCEC; A2 DEFENSIVE; A2
              DEFENSIFE; A2 COMBAT;
            </div>
            <div>
              <img src="https://i.postimg.cc/PqdrYJkB/mercs.jpg" alt="Mercs" />
            </div>
          </div>
        </CardBody>
      </Card>
    ),
  },
  {
    name: 'Skins',
    content: (
      <Card>
        <CardBody>
          <div>
            <div style={{ color: 'white' }}>TAGS: SKINS; CHARM SKINS; RING SKINS; JEWEL SKINS;</div>
            <div>
              <img src="https://i.postimg.cc/RFN8mK0R/skins-kopia.jpg" alt="Skins" />
            </div>
          </div>
        </CardBody>
      </Card>
    ),
  },
];
export default function Recipes() {
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <NavPills
          queryKey={'r'}
          alignCenter
          color="primary"
          onChange={() => {}}
          tabs={[
            {
              tabName: 'all',
              tabButton: (
                <span style={{ display: 'block' }}>
                  <img style={{ width: '64px' }} src={d2rsIcon} alt="d2rs" />
                </span>
              ),
              tabContent: (
                <span>
                  {recipesAndMisc.map((entry) => (
                    <div key={entry.name}>{entry.content}</div>
                  ))}
                </span>
              ),
            },
            ...recipesAndMisc.map((obj, index) => ({
              tabName: obj.name,
              tabButton: (
                <span style={{ display: 'block' }} key={index}>
                  {obj.name}
                </span>
              ),
              tabContent: obj.content,
            })),
          ]}
        ></NavPills>
      </GridItem>
    </GridContainer>
  );
}
